import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';

import type { ViewType } from '../../../../../../../../common/types/context';
import type {
	ScreenTabsChangesPublic,
	ScreenTabsDataPublic,
} from '../../../../../../../../common/types/screen-tabs';

import {
	baseRequiredReadScopes,
	baseRequiredWriteScopes,
	type ScreenTabsScopes,
} from './screen-tabs-scopes';

const includeCoarseScopes = (requiredScopes: ScreenTabsScopes, moduleScopes: readonly string[]) =>
	requiredScopes.coarse.length > 0 &&
	requiredScopes.coarse.every((requiredScope) => moduleScopes.includes(requiredScope));

const includeGranularScopes = (requiredScopes: ScreenTabsScopes, moduleScopes: readonly string[]) =>
	requiredScopes.granular.length > 0 &&
	requiredScopes.granular.every((requiredScope) => moduleScopes.includes(requiredScope));

export const filterScreenTabsBasedOnReadScopes = (
	moduleScopes: readonly string[],
	screenTabs: ScreenTabsDataPublic,
): ScreenTabsDataPublic => {
	if (
		includeCoarseScopes(baseRequiredReadScopes, moduleScopes) ||
		includeGranularScopes(baseRequiredReadScopes, moduleScopes)
	) {
		return screenTabs;
	}

	return [];
};

export const moduleIncludesScreenTabsWriteScopes = (
	viewType: ViewType,
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	moduleScopes: readonly string[],
	screenTabsChanges: ScreenTabsChangesPublic,
): boolean => {
	if (
		includeCoarseScopes(baseRequiredWriteScopes, moduleScopes) ||
		includeGranularScopes(baseRequiredWriteScopes, moduleScopes)
	) {
		return true;
	}

	if (Array.isArray(screenTabsChanges) && screenTabsChanges.length > 0) {
		fireOperationalEvent(createAnalyticsEvent, {
			action: 'missingScope',
			actionSubject: 'jiraUiModifications.screenTabs',
			attributes: {
				access: 'write',
				viewType,
			},
		});
	}

	return false;
};
